import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmationModal from 'src/components/modals/ConfirmationModal/ConfirmationModal';
import { useOverlay } from 'src/providers/OverlayProvider';
import UserCreateWizard from './UserCreateWizard';
import { useOverlayCloseGuard } from './useOverlayCloseGuard';

/**
 * Overlay frame around the create wizard: owns "are you sure?" on close and the
 * Escape / outside-click routing. Closing on success is the wizard's call.
 */
const UserCreateOverlay: React.FC = () => {
  const { t } = useTranslation();
  const { onClose } = useOverlay();
  const [isCloseConfirmationOpen, setIsCloseConfirmationOpen] = useState(false);

  const containerRef = useOverlayCloseGuard(() => setIsCloseConfirmationOpen(true), !isCloseConfirmationOpen);

  const handleConfirmClose = (confirmed: boolean) => {
    setIsCloseConfirmationOpen(false);
    if (confirmed) onClose();
  };

  return (
    <>
      <div
        ref={containerRef}
        data-overlay-handles-escape="true"
        data-overlay-handles-outside="true"
        className="flex min-h-0 flex-1 flex-col">
        <UserCreateWizard onRequestClose={() => setIsCloseConfirmationOpen(true)} onCreated={onClose} />
      </div>

      <ConfirmationModal
        isOpen={isCloseConfirmationOpen}
        title={t('general.close_overlay')}
        description={t('general.close_overlay_confirmation')}
        onClose={handleConfirmClose}
      />
    </>
  );
};

export default UserCreateOverlay;
